import {defaultTo} from 'ramda';

import {Nullish} from 'shared/web';

import {EitherQuantityOrError} from '../types/basket/EitherQuantityOrError';
import {IdentifiableBasketItem} from '../types/basket/IdentifiableBasketItem';
import {useBasketItemIdsSet} from './useBasketItemIdsSet';

/**
 * Tracks basket items whose quantity input currently holds an invalid value,
 * i.e. items that cannot be saved at all.
 */
export function useInvalidBasketItemsIds(basketItems: IdentifiableBasketItem[] | Nullish) {
  const {hasIds, setId} = useBasketItemIdsSet(basketItems);

  const setInvalidBasketItemId = (itemId: string, quantity: EitherQuantityOrError) =>
    setId(itemId, defaultTo(false, quantity.hasError));

  return {setInvalidBasketItemId, hasInvalidBasketItems: hasIds};
}
